// extracted by mini-css-extract-plugin
export default {"text":"cVq196VT","check":"TiUXXjBJ","increase":"lk0WJbL5"};